import { Box, Typography } from "@mui/material";

// Fila de cifras destacadas (Fichado · Previsto · Diferencia) de Mi jornada y Mis fichajes.
export interface CifraJornada {
    etiqueta: string;
    valor: string;
    color?: string; // color del tema (p. ej. 'warning.dark'); sin él, el del texto
}

// Diferencia en naranja si falta tiempo y en verde si se ha pasado
export const colorDiferencia = (ms: number): string | undefined =>
    Math.floor(Math.abs(ms) / 60000) === 0 ? undefined : ms < 0 ? 'warning.dark' : 'success.dark';

const CifrasJornada = ({ cifras }: { cifras: CifraJornada[] }) => (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: 4, rowGap: 1 }}>
        {cifras.map(c => (
            <Box key={c.etiqueta}>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>{c.etiqueta}</Typography>
                <Typography variant="h6" sx={{ fontWeight: 600, color: c.color, lineHeight: 1.3 }}>{c.valor}</Typography>
            </Box>
        ))}
    </Box>
);

export default CifrasJornada;
